import { useCurrency } from '../contexts/CurrencyContext';

const FREE_SHIPPING_THRESHOLD = 1500; // PHP — adjust as needed

/**
 * #13 — Cart progress bar. AOV nudge: "₱X away from free shipping".
 * Pass `subtotal` in PHP. Displays nothing if subtotal is 0.
 */
export default function CartProgressBar({ subtotal }) {
  const { formatPrice } = useCurrency();
  const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - (subtotal || 0));
  const pct = Math.min(100, ((subtotal || 0) / FREE_SHIPPING_THRESHOLD) * 100);
  const unlocked = remaining === 0 && (subtotal || 0) > 0;

  if (!subtotal || subtotal <= 0) return null;

  return (
    <div className="bg-[#141414] border border-white/8 p-4 sm:p-5" data-testid="cart-progress-bar">
      <div className="flex items-center justify-between mb-2.5 gap-3 flex-wrap">
        <p className="text-white text-sm font-sans">
          {unlocked ? (
            <span className="text-[#1C7D3F] font-medium">🎉 You unlocked FREE shipping!</span>
          ) : (
            <>You're <span className="text-[#D4AF37] font-medium">{formatPrice(remaining)}</span> away from <span className="font-medium">FREE shipping</span></>
          )}
        </p>
        <p className="text-white/40 text-[11px] font-sans whitespace-nowrap">
          {formatPrice(subtotal)} / {formatPrice(FREE_SHIPPING_THRESHOLD)}
        </p>
      </div>
      <div className="h-[5px] bg-white/8 overflow-hidden">
        <div
          className="h-full transition-all duration-500"
          style={{
            width: `${pct}%`,
            background: unlocked ? '#1C7D3F' : 'linear-gradient(90deg, #D4AF37, #E5C75A)',
          }}
          data-testid="cart-progress-fill"
        />
      </div>
    </div>
  );
}
